__turbopack_context__.v({
  "activities_heading": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activities_heading",
  "activity_nav_child": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activity_nav_child",
  "activity_nav_items_left": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activity_nav_items_left",
  "activity_nav_items_right": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activity_nav_items_right",
  "activity_nav_items_right_btn": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activity_nav_items_right_btn",
  "activity_text": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__activity_text",
  "img_box": "RidesandactivitiesSubmenu-module-scss-module__ui-UAa__img_box",
});
